import parseUtcDate from '../common/utils/parseUtcDate'

import formatDate from './formatDate'

const displayDateTime = (date: string): string => (date ? formatDate(parseUtcDate(date), 'yyyy-MM-dd HH:mm') : '')

export default displayDateTime
